import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';

declare let hj: any;

function getHotjar(): any {
  return hj;
}

@Injectable({
  providedIn: 'root'
})
export class HotjarService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  private debug: boolean = false;

  get hotjar(): any {
    return getHotjar();
  }

  public isLoaded(): boolean {
    try {
      return hj.scriptLoaded;
    } catch (e) {
      this.debugLogger('Is offline or not loaded');
      return false;
    }
  }

  private load(hotjarId: number): void {
    try {
      const load = (h: any, o: any, t: any, j: any, a: any, r: any) => {
        h.hj =
          h.hj ||
          ((...args: any[]) => {
            (h.hj.q = h.hj.q || []).push(args);
          });

        h._hjSettings = { hjid: hotjarId, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];

        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;

        a.appendChild(r);
      };

      load(
        window,
        document,
        'https://static.hotjar.com/c/hotjar-',
        '.js?sv=',
        null,
        null
      );

      this.debugLogger('Has been configured');
    } catch (e) {
      this.debugLogger('Error configuring');
    }
  }

  public setConfig(hotjarId?: number, debug?: boolean): void {
    if (debug) {
      this.debug = debug;
    }

    // hjid check
    if (!hotjarId) {
      this.debugLogger('No identifier provided');
      return;
    }

    // check loaded
    if (this.isLoaded()) {
      return;
    }

    this.load(hotjarId);
  }

  private debugLogger(message: string): void {
    if (this.debug) {
      console.log('[Hotjar] ' + message);
    }
  }
}
